'use strict';

/* eslint new-cap: 0 */
/* eslint no-undef: 0 */
/* eslint camelcase: 0 */
var api = {
        dvbManager: window.dvbManager,
        epgManager: window.epgManager,
        gSTB: window.gSTB,
        pvrManager: window.pvrManager,
        stbDownloadManager: window.stbDownloadManager,
        stbStorage: window.stbStorage,
        stbUpdate: window.stbUpdate,
        stbUPnP: window.stbUPnP,
        stbWebWindow: window.stbWebWindow,
        stbWindowMgr: window.stbWindowMgr,
        timeShift: window.timeShift,
        stbPlayerManager: window.stbPlayerManager,
        stbEvent: window.stbEvent,
        exit: function () {
            window.location.href = require('stb-referrer')() || 'file:///home/web/services.html';
        }
    },
    inputLanguage = require('./environment').language,
    settings = {},
    memory;


if ( DEVELOP ) {
    memory = gSTB.RDir('GetMemoryInfo');

    if ( memory && memory.indexOf('MemTotal') !== -1 ) {
        if ( !String.prototype.trim ) {
            (function () {
                /* eslint no-extend-native: 0 */
                // Вырезаем BOM и неразрывный пробел
                String.prototype.trim = function () {
                    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
                };
            })();
        }
        memory = memory.split('\n');

        memory = memory.filter(Boolean);

        memory = memory.map(function ( item ) {
            var data = item.split(':');

            item = {};
            item[data[0].trim()] = data[1].trim();

            return item;
        });

        debug('device')('memory: ' + JSON.stringify(memory));
    }
}


Object.defineProperty(settings, 'inputLanguage', {
    set: function ( lang ) {
        inputLanguage = lang;
        gSTB.SetInputLang(lang);
    },
    get: function () {
        return inputLanguage;
    }
});

window.extendCorePrototype('tools', {
    hash: gSTB.GetHashVersion1,
    uid: gSTB.GetUID,
    debug: typeof window.debug === 'function' || gSTB.Debug
});


window.extendCorePrototype('settings', settings);

window.extendCorePrototype('device', {
    model: gSTB.GetDeviceModelExt(),
    serialNumber: gSTB.GetDeviceSerialNumber(),
    vendor: gSTB.GetDeviceVendor(),
    versionHardware: gSTB.GetDeviceVersionHardware(),
    activeBank: gSTB.GetDeviceActiveBank(),
    imageDescription: gSTB.GetDeviceImageDesc(),
    imageVersion: gSTB.GetDeviceImageVersion(),
    imageVersionCurrent: gSTB.GetDeviceImageVersionCurrent(),
    mac: gSTB.GetDeviceMacAddress(),
    memory: memory
});

//window.dvbManager         = null;
//window.epgManager         = null;
//window.gSTB               = null;
//window.pvrManager         = null;
//window.stbDownloadManager = null;
//window.stbStorage         = null;
//window.stbUpdate          = null;
//window.stbUPnP            = null;
//window.stbWebWindow       = null;
//window.stbWindowMgr       = null;
//window.timeShift          = null;
//window.stbPlayerManager      = null;


module.exports = api;
